import api from './axios'
import { authHeader } from '../helpers'
import { authService } from './authentication.service'

export const materielService = {
    getMateriels,
    deleteMateriel,
    getTypesMateriels,
    addMateriel,
    editMateriel
}

function getMateriels() {
    return api.get('/Materiel', {
        headers: authHeader()
    }).then(authService.handleResponse)
}

function deleteMateriel(guid) {
    return api.delete(`/Materiel/${encodeURIComponent(guid)}`, {
        headers: authHeader()
    }).then(authService.handleResponse)
}

function getTypesMateriels() {
    return api.get('/Materiel/types', {
        headers: authHeader()
    }).then(authService.handleResponse)
}

function addMateriel(materiel) {
    return api.post('/Materiel', materiel, {
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json'
        }
    }).then(authService.handleResponse)
}

function editMateriel(materiel) {
    return api.patch('/Materiel', materiel, {
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json'
        }
    }).then(authService.handleResponse)
}
